/**
 * NativeWaves Content API v1
 *
 * Contact: support@nativewaves.com
 *
 * DO NOT EDIT THIS CLASS MANUALLY!
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class ExternalStoresApi extends runtime.BaseAPI {
    /**
     * Get a paginated list of external stores.
     */
    async externalStoresGetRaw(requestParameters, initOverrides) {
        if (requestParameters.environmentId === null ||
            requestParameters.environmentId === undefined) {
            throw new runtime.RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling externalStoresGet.');
        }
        const queryParameters = {};
        if (requestParameters.environmentId !== undefined) {
            queryParameters['environmentId'] = requestParameters.environmentId;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.resourceState) {
            queryParameters['resourceState'] = requestParameters.resourceState;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/externalStores`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of external stores.
     */
    async externalStoresGet(requestParameters, initOverrides) {
        const response = await this.externalStoresGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a external store.
     */
    async externalStoresPostRaw(requestParameters, initOverrides) {
        if (requestParameters.contentExternalStoreInsert === null ||
            requestParameters.contentExternalStoreInsert === undefined) {
            throw new runtime.RequiredError('contentExternalStoreInsert', 'Required parameter requestParameters.contentExternalStoreInsert was null or undefined when calling externalStoresPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/externalStores`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.contentExternalStoreInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a external store.
     */
    async externalStoresPost(requestParameters, initOverrides) {
        const response = await this.externalStoresPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List access keys
     */
    async externalStoresStoreIdAccessKeysGetRaw(requestParameters, initOverrides) {
        if (requestParameters.storeId === null ||
            requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId', 'Required parameter requestParameters.storeId was null or undefined when calling externalStoresStoreIdAccessKeysGet.');
        }
        const queryParameters = {};
        if (requestParameters.keyId !== undefined) {
            queryParameters['keyId'] = requestParameters.keyId;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/externalStores/{storeId}/accessKeys`.replace(`{${'storeId'}}`, String(requestParameters.storeId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List access keys
     */
    async externalStoresStoreIdAccessKeysGet(requestParameters, initOverrides) {
        const response = await this.externalStoresStoreIdAccessKeysGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete an access key
     */
    async externalStoresStoreIdAccessKeysKeyIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.storeId === null ||
            requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId', 'Required parameter requestParameters.storeId was null or undefined when calling externalStoresStoreIdAccessKeysKeyIdDelete.');
        }
        if (requestParameters.keyId === null ||
            requestParameters.keyId === undefined) {
            throw new runtime.RequiredError('keyId', 'Required parameter requestParameters.keyId was null or undefined when calling externalStoresStoreIdAccessKeysKeyIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/externalStores/{storeId}/accessKeys/{keyId}`
                .replace(`{${'storeId'}}`, String(requestParameters.storeId))
                .replace(`{${'keyId'}}`, String(requestParameters.keyId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete an access key
     */
    async externalStoresStoreIdAccessKeysKeyIdDelete(requestParameters, initOverrides) {
        await this.externalStoresStoreIdAccessKeysKeyIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get an access key
     */
    async externalStoresStoreIdAccessKeysKeyIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.storeId === null ||
            requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId', 'Required parameter requestParameters.storeId was null or undefined when calling externalStoresStoreIdAccessKeysKeyIdGet.');
        }
        if (requestParameters.keyId === null ||
            requestParameters.keyId === undefined) {
            throw new runtime.RequiredError('keyId', 'Required parameter requestParameters.keyId was null or undefined when calling externalStoresStoreIdAccessKeysKeyIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/externalStores/{storeId}/accessKeys/{keyId}`
                .replace(`{${'storeId'}}`, String(requestParameters.storeId))
                .replace(`{${'keyId'}}`, String(requestParameters.keyId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get an access key
     */
    async externalStoresStoreIdAccessKeysKeyIdGet(requestParameters, initOverrides) {
        const response = await this.externalStoresStoreIdAccessKeysKeyIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit an access key
     */
    async externalStoresStoreIdAccessKeysKeyIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.storeId === null ||
            requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId', 'Required parameter requestParameters.storeId was null or undefined when calling externalStoresStoreIdAccessKeysKeyIdPatch.');
        }
        if (requestParameters.keyId === null ||
            requestParameters.keyId === undefined) {
            throw new runtime.RequiredError('keyId', 'Required parameter requestParameters.keyId was null or undefined when calling externalStoresStoreIdAccessKeysKeyIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/externalStores/{storeId}/accessKeys/{keyId}`
                .replace(`{${'storeId'}}`, String(requestParameters.storeId))
                .replace(`{${'keyId'}}`, String(requestParameters.keyId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.basicIdentityPoolUserEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit an access key
     */
    async externalStoresStoreIdAccessKeysKeyIdPatch(requestParameters, initOverrides) {
        const response = await this.externalStoresStoreIdAccessKeysKeyIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new access key
     */
    async externalStoresStoreIdAccessKeysPostRaw(requestParameters, initOverrides) {
        if (requestParameters.storeId === null ||
            requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId', 'Required parameter requestParameters.storeId was null or undefined when calling externalStoresStoreIdAccessKeysPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/externalStores/{storeId}/accessKeys`.replace(`{${'storeId'}}`, String(requestParameters.storeId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.basicIdentityPoolUserKeyInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new access key
     */
    async externalStoresStoreIdAccessKeysPost(requestParameters, initOverrides) {
        const response = await this.externalStoresStoreIdAccessKeysPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a external store. This will not delete any content objects.
     */
    async externalStoresStoreIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.storeId === null ||
            requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId', 'Required parameter requestParameters.storeId was null or undefined when calling externalStoresStoreIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/externalStores/{storeId}`.replace(`{${'storeId'}}`, String(requestParameters.storeId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a external store. This will not delete any content objects.
     */
    async externalStoresStoreIdDelete(requestParameters, initOverrides) {
        await this.externalStoresStoreIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get a external store.
     */
    async externalStoresStoreIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.storeId === null ||
            requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId', 'Required parameter requestParameters.storeId was null or undefined when calling externalStoresStoreIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/externalStores/{storeId}`.replace(`{${'storeId'}}`, String(requestParameters.storeId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a external store.
     */
    async externalStoresStoreIdGet(requestParameters, initOverrides) {
        const response = await this.externalStoresStoreIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit a external store.
     */
    async externalStoresStoreIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.storeId === null ||
            requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId', 'Required parameter requestParameters.storeId was null or undefined when calling externalStoresStoreIdPatch.');
        }
        if (requestParameters.contentExternalStoreEdit === null ||
            requestParameters.contentExternalStoreEdit === undefined) {
            throw new runtime.RequiredError('contentExternalStoreEdit', 'Required parameter requestParameters.contentExternalStoreEdit was null or undefined when calling externalStoresStoreIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/externalStores/{storeId}`.replace(`{${'storeId'}}`, String(requestParameters.storeId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.contentExternalStoreEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit a external store.
     */
    async externalStoresStoreIdPatch(requestParameters, initOverrides) {
        const response = await this.externalStoresStoreIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const ExternalStoresGetResourceStateEnum = {
    Active: 'ACTIVE',
    Disposed: 'DISPOSED',
    Deleted: 'DELETED',
};
//# sourceMappingURL=ExternalStoresApi.js.map